import moment from 'moment-timezone';

import { internationalCountries } from '../components/internationalPhoneInput';

const supportedCountryCodes = internationalCountries.map(({ code }) => code);

const DEPRECATED_TIMEZONE_ALIASES = {
    'Asia/Calcutta': 'Asia/Kolkata',
    'Europe/Kiev': 'Europe/Kyiv',
};

const resolveTimezone = (timeZone) => DEPRECATED_TIMEZONE_ALIASES[timeZone] ?? timeZone;

const getCountryCodesFromTimezone = (timeZone) => {
    const zone = timeZone ? moment.tz.zone(resolveTimezone(timeZone)) : null;

    return zone?.countries?.() ?? [];
};

const getCountryCodeFromTimezone = (timeZone) => {
    const countryCodes = getCountryCodesFromTimezone(timeZone);
    const filteredCountryCodes = countryCodes.filter((code) => supportedCountryCodes.includes(code));

    if (filteredCountryCodes.length === 1) {
        return filteredCountryCodes[0];
    }

    return null;
};

const getCountryCodeFromLanguage = (language) => {
    const regionCode = language?.includes('-') ? language.split('-')[1] : null;

    return regionCode?.toUpperCase() ?? null;
};

const detectCountryCode = () => {
    const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
    const language = navigator.language || navigator.userLanguage;
    let countryCode = getCountryCodeFromTimezone(timeZone);

    if (!countryCode) {
        countryCode = getCountryCodeFromLanguage(language);
    }

    return countryCode;
};

export default detectCountryCode;
